<template>
  <div class="min-h-screen bg-white dark:bg-black">
    <component 
      :is="layout" 
      v-if="layout"
    >
      <router-view />
    </component>
    <router-view v-else />
    <NotificationsVue />
  </div>
</template>

<script lang="ts" setup>
import NotificationsVue from '@/shared/components/Notifications.vue'
import { onMounted, ref, watch, computed } from 'vue'
import { useRoute } from 'vue-router'

const isDarkMode = ref(false)
const route = useRoute()

// Initialize dark mode
onMounted(() => {
  // Check localStorage first
  const savedTheme = localStorage.getItem('theme')
  if (savedTheme) {
    isDarkMode.value = savedTheme === 'dark'
  } else {
    // Check system preference
    isDarkMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches
  }
  
  // Apply initial theme
  updateTheme()
})

// Watch for changes and update
watch(isDarkMode, updateTheme)

function updateTheme() {
  if (isDarkMode.value) {
    document.documentElement.classList.add('dark')
  } else {
    document.documentElement.classList.remove('dark')
  }
  // Save preference
  localStorage.setItem('theme', isDarkMode.value ? 'dark' : 'light')
}

const layout = computed(() => {
  return route.meta.layout;
});
</script>

<style>
html.dark {
  color-scheme: dark;
  background-color: black;
}

html {
  background-color: white;
}

body {
  min-height: 100vh;
}
</style>